module.exports = __webpack_public_path__ + "img/deco-title.167c82ed.svg";